import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="web-share"
export default class WebShareController extends Controller<HTMLElement> {
  static values = { title: String, text: String, url: String, files: String }

  declare titleValue: string
  declare textValue: string
  declare urlValue: string
  declare filesValue: string

  connect() {
    this.element.hidden = !navigator.canShare
  }

  async share() {
    await navigator.share(await this.#getShareData())
  }

  async #getShareData() {
    const data: ShareData = { title: this.titleValue, text: this.textValue }

    if (this.urlValue) data.url = this.urlValue

    if (this.filesValue) data.files = [await this.#getFileObject()]

    return data
  }

  async #getFileObject() {
    const response = await fetch(this.filesValue)
    const blob = await response.blob()
    const randomPrefix = `Nuggit_${Math.random().toString(36).slice(2)}`
    const fileName = `${randomPrefix}.${blob.type.split("/").pop()}`

    return new File([blob], fileName, { type: blob.type })
  }
}
